export default __webpack_public_path__ + "static/media/landing-background.3b7693f2.jpg";